module.exports = __webpack_public_path__ + "producr-dried fresh-grass-04.jpg?91526c514a477a75a5aa58c6fee06ea1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-04.jpg
// module id = 62
// module chunks = 0